// plugins/cachePlugin.ts
import { PiniaPluginContext } from 'pinia'

export function cachePlugin(context: PiniaPluginContext) {
	const { store } = context
	// 只针对特定模块（例如 'sys'）
	if (store.$id === 'sys') {
		const cachedData = localStorage.getItem(`pinia-cache-${store.$id}`)
		if (cachedData) {
			store.$patch(JSON.parse(cachedData) as typeof store.$state)
		}
		store.$subscribe((_, state) => {
			localStorage.setItem(`pinia-cache-${store.$id}`, JSON.stringify(state))
		})
	}
}
